"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 */
class ViewResponseHandler {
    constructor(options) {
        this.options = options;
    }
    async handle(response) {
        var _a;
        const { jsonCallback, callback } = (_a = this.options) !== null && _a !== void 0 ? _a : {};
        if (jsonCallback !== undefined) {
            const data = await response.json();
            return jsonCallback(data);
        }
        if (callback !== undefined) {
            return callback(response);
        }
        return response.text();
    }
}
exports.default = ViewResponseHandler;
//# sourceMappingURL=ViewResponseHandler.js.map